import { set, toggle } from '@/utils/vuex.js'

export default {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  setUser: set('user'),
  toggleDrawer: toggle('drawer')
}
